import { TBillingRateType } from '../types/TRatesState';

export const hasEditableRateAmount = (rateType: TBillingRateType): boolean =>
  rateType !== 'TIER_RATE' && rateType !== 'DISALLOWED';
